<template>
  <main>
    <div>
      <gl-button @click="swapBaseAndCompare">
        対象・比較を入れ替える
      </gl-button>
    </div>
    <md-tabs
      :md-active-tab="activeTab"
      @md-changed="$emit('update:activeTab', $event)"
    >
      <md-tab id="base" md-label="対象">
        <div>
          <md-radio v-model="base.selectMode" value="category">
            分類
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
          <md-radio v-model="base.selectMode" value="item">
            商品
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
        </div>
        <div>
          <filter-item-category
            v-if="base.selectMode === 'category'"
            :company="company"
            v-bind.sync="base"
          />
          <filter-item
            v-if="base.selectMode === 'item'"
            :company="company"
            v-bind.sync="base"
          />
        </div>
        <!-- <filter-item-category v-bind.sync="base" /> -->
      </md-tab>
      <md-tab id="compare" md-label="比較">
        <div>
          <md-radio v-model="compare.selectMode" value="category">
            分類
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
          <md-radio v-model="compare.selectMode" value="item">
            商品
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
        </div>
        <div>
          <filter-item-category
            v-if="compare.selectMode === 'category'"
            :company="company"
            v-bind.sync="compare"
          />
          <filter-item
            v-if="compare.selectMode === 'item'"
            :company="company"
            v-bind.sync="compare"
          />
        </div>
      </md-tab>
    </md-tabs>
  </main>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'
import FilterItem from '@/components/FilterItem.vue'
import FilterItemCategory from '@/components/FilterItemCategory.vue'

export default {
  components: { FilterItem, FilterItemCategory },
  mixins: [ErrorReport],
  props: {
    company: {
      type: String,
    },
    base: {
      company: {
        type: String,
        required: true,
      },
      items: {
        type: Array,
        default: () => [],
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    compare: {
      company: {
        type: String,
        required: true,
      },
      items: {
        type: Array,
        default: () => [],
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    activeTab: {
      type: String,
      default: 'base',
      validator(v) {
        return ['base', 'compare'].includes(v)
      },
    },
  },
  methods: {
    swapBaseAndCompare() {
      this.$emit('update:base', {
        ...this.compare,
        categories: this.compare.categories,
        items: this.compare.items,
        selectMode: this.compare.selectMode,
        key: new Date().getTime().toString(),
      })
      this.$emit('update:compare', {
        ...this.base,
        categories: this.base.categories,
        items: this.base.items,
        selectMode: this.base.selectMode,
        key: new Date().getTime().toString(),
      })
    },
  },
  computed: {
    errors() {
      const errors = []
      for (let error of this.base.errors) {
        errors.push('対象：' + error)
      }
      for (let error of this.compare.errors) {
        errors.push('比較：' + error)
      }
      return errors
    },
  },
}
</script>
